import type { FaireProductEntity } from "../../entity_types/product";

export const p_tz7mu7aqxw: FaireProductEntity = {
  token: "p_tz7mu7aqxw",
  type: "product",
  name: "Cowboy - Hardcover",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/b91538d4df1dfc2a7143a11ef22115e1442f9e7c05304370e97817755a08a7bd.jpeg",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/7cff474cb69f53dba2940c39ca7119bfa4e85bff6a3e14babd39a69a3c144e85.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
